import HighlightLabel from 'LuxKit/Label/HighlightLabel'
import { useIntl } from 'react-intl'

export const WEEKLY_BOOKINGS_THRESHOLD = 5

export function getWeeklyEstimate(salesCount: number): number {
  return Math.round(salesCount / 4)
}

interface Props {
  salesCount: number;
}

function ExperienceBookedThisWeekPill({ salesCount }: Props) {
  const intl = useIntl()
  const weeklyEstimate = getWeeklyEstimate(salesCount)

  if (weeklyEstimate < WEEKLY_BOOKINGS_THRESHOLD) {
    return null
  }

  return (
    <HighlightLabel variant="primaryLight">
      {intl.formatMessage(
        {
          id: 'zhA-XNKCCvDIgSpN0RnR',
          defaultMessage: '{count} Booked this week',
          description:
            'Social proof badge showing how many people booked this experience recently',
        },
        { count: weeklyEstimate },
      )}
    </HighlightLabel>
  )
}

export default ExperienceBookedThisWeekPill
